import Auth from '../Auth';

/**
 * Simple utility functions for managing snapshot favorites
 * Calls server-side API endpoints instead of direct Firebase operations
 */

/**
 * Toggle a snapshot's favorite status
 */
export async function toggleSnapshotFavorite(_userId: string, documentId: string, snapshotId: string): Promise<boolean> {
  const data = await Auth.fetchWithIdToken('/api/document/snapshots/toggle-snapshot-favorite', {
    documentId,
    snapshotId,
  });

  return data.isFavorite;
}

/**
 * Set favorite status for a snapshot
 */
export async function setSnapshotFavorite(_userId: string, documentId: string, snapshotId: string, isFavorite: boolean): Promise<void> {
  await Auth.fetchWithIdToken('/api/document/snapshots/set-snapshot-favorite', {
    documentId,
    snapshotId,
    isFavorite,
  });
}
